import { ComponentType } from 'react'

export default <T>(WrappedComponent: ComponentType<T>): string =>
  WrappedComponent.displayName || WrappedComponent.name || 'Component'
